<template>
<div>
    <!-- <base-header v-once pageName="설문하기" :popup="true" :reload="reload" :bfClose="true" v-on:beforeClose="beforeClose"></base-header> -->
    <base-header 
      v-once 
      :prevBtnShow="true"
      pageName="설문하기"></base-header>
    
    <section id="wrap" v-for="info in info" v-bind:key="info.itemSqno">
        <div class="survey" >
            <h4>{{info.titl}}</h4>
            <p>{{info.expi}}</p>
            <dl>
                <dt>대상</dt>
                <dd>{{info.pstnTyp}}</dd>
                <dt>진행일</dt>
                <dd>{{info.sttTime}} ~ {{info.endTime}}</dd>
            </dl>

      <template v-for="(item , i) in list">
          <!-- 선택형-->
          <div class="item" v-bind:key="item.itemSqno" v-if="item.qsitTypCd === 'SQT01' || item.qsitTypCd === 'SQT02'" v-bind:id="'div'+item.itemSqno">
            <h6>{{i+1}}.{{item.titl}}{{item.essnYn === 'Y' ? '*' : ''}}</h6>
              <ul>
                 <template v-for="(itemOption  , index) in optionList">
                  <li v-bind:key="itemOption.optnSqno" v-if="itemOption.itemSqno === item.itemSqno" :v-once="picked(index)">
                      <span class="radio" v-if="item.qsitTypCd === 'SQT01'" >
                          <input type="radio"  :disabled="disableChk()" @click="chkEtc1(index , itemOption.itemSqno ,  itemOption.optnTyp)"
                           v-bind:value="itemOption.optnSqno" v-model="itemOption.chkOptnSqno" v-bind:name="itemOption.itemSqno" v-bind:id="itemOption.itemSqno+'-'+itemOption.optnSqno">
                          <label v-bind:for="itemOption.itemSqno+'-'+itemOption.optnSqno" >{{itemOption.optnTyp === 'N' ? itemOption.cntn : '기타'}}</label>
                      </span> 
                      <span class="checkbox" v-if="item.qsitTypCd === 'SQT02'" >
                          <input type="checkbox"  :v-once="checked(index)" v-bind:value="itemOption.optnSqno"  :disabled="disableChk()"
                          v-model="itemOption.chkBoxSqno" v-bind:name="itemOption.itemSqno+'-'+itemOption.optnSqno" 
                          v-bind:id="itemOption.itemSqno+'-'+itemOption.optnSqno"  @click="chkEtc2(index , itemOption.optnTyp)">
                          <label v-bind:for="itemOption.itemSqno+'-'+itemOption.optnSqno">{{itemOption.optnTyp === 'N' ? itemOption.cntn : '기타'}}</label>
                      </span>

                      <figure v-if="itemOption.fileSqno != '@'"><img v-bind:src="itemOption.fileSqno" alt=""></figure>
                      <input  :disabled="disableEtc(index)" 
                        v-if="itemOption.optnTyp != 'N'" 
                        type="text"
                        maxlength="50"
                        v-model="itemOption.rply" 
                        v-bind:name="'txt'+itemOption.itemSqno+'-'+itemOption.optnSqno" 
                        v-bind:id="'txt'+itemOption.itemSqno+'-'+itemOption.optnSqno" 
                        placeholder="내용입력">
                  </li>
                  </template>
              </ul>
          </div>
          <!-- 선호도형-->
          <div class="item two"  v-bind:key="item.itemSqno" v-if="item.qsitTypCd === 'SQT03'" v-bind:id="'div'+item.itemSqno">
            <h6>{{i+1}}.{{item.titl}}{{item.essnYn === 'Y' ? '*' : ''}}</h6>
              <div class="level">
                <em>{{item.prfnLow}}</em>
                 <template v-for="(itemOption  , index) in optionList">
                  <span class="radio"  v-bind:key="itemOption.optnSqno" v-if="itemOption.itemSqno === item.itemSqno" >
                    <input type="radio" :v-once="picked(index)" :disabled="disableChk()"
                    v-bind:value="itemOption.optnSqno" v-model="itemOption.chkOptnSqno" v-bind:name="itemOption.itemSqno" v-bind:id="itemOption.itemSqno+'-'+itemOption.optnSqno">
                    <label v-bind:for="itemOption.itemSqno+'-'+itemOption.optnSqno" @click="chkEtc1(index , itemOption.itemSqno ,  itemOption.optnTyp)">{{itemOption.cntn}}</label>
                  </span>
                  </template>
                <em>{{item.prfnHig}}</em>
                
              </div>
          </div>
          <!-- 순위형-->
          <div class="item"  v-bind:key="item.itemSqno" v-if="item.qsitTypCd === 'SQT04'" v-bind:id="'div'+item.itemSqno">
            <h6>{{i+1}}.{{item.titl}}{{item.essnYn === 'Y' ? '*' : ''}}</h6>
            <p>최소 1개부터 최대 {{chkLength(item.itemSqno)}}개까지 순위를 선택해 주세요.</p>
            <ul class="ranking">
               <template v-for="(itemOption , index) in optionList">
                
                <li v-if="itemOption.itemSqno === item.itemSqno" :key="itemOption.optnSqno">

                      <base-selectbox selectName="SelectBox" 
                        :survey="false"
                        :surveyIdx=index
                        v-on:surveyVal="selectSearch"
                        :default="selectDefault(index)"
                        :valName="'rply'"
                        :only="false"
                        :options="makeSelect(item.itemSqno)"
                      ></base-selectbox>

                    <em class="opt" >{{itemOption.cntn}}</em>
                 
                </li>
        
                </template>
            </ul>
          </div>
           <!-- 단문형-->
          <div class="item" v-bind:key="item.itemSqno" v-if="item.qsitTypCd === 'SQT05'" v-bind:id="'div'+item.itemSqno">
            <h6>{{i+1}}.{{item.titl}}{{item.essnYn === 'Y' ? '*' : ''}}</h6>
            <template v-for="(itemOption , index) in optionList">
            <input type="text" 
              class="text" 
              maxlength="50"
              placeholder="내용입력" 
              :v-once="chkTxt(index)" 
              :disabled="disableChk()"
              @click="chkTxt(index)" 
              v-model="itemOption.rply" 
              v-bind:name="itemOption.itemSqno" 
              v-bind:id="itemOption.optnSqno" 
              v-bind:key="itemOption.optnSqno" 
              v-if="itemOption.itemSqno === item.itemSqno">
            </template>
          </div>
          <!-- 장문형-->
          <div class="item" v-bind:key="item.itemSqno" v-if="item.qsitTypCd === 'SQT06'" v-bind:id="'div'+item.itemSqno">
            <h6>{{i+1}}.{{item.titl}}{{item.essnYn === 'Y' ? '*' : ''}}</h6>
            <div class="memo">
              <template v-for="(itemOption , index) in optionList">
                <textarea  maxlength="200"
                  @click="chkTxt(index)" 
                  :v-once="chkTxt(index)" 
                  v-model="itemOption.rply" 
                  :disabled="disableChk()"
                  placeholder="내용을 입력해 주시기 바랍니다." 
                  v-bind:name="itemOption.itemSqno" 
                  v-bind:id="itemOption.optnSqno" 
                  v-bind:key="itemOption.optnSqno" 
                  v-if="itemOption.itemSqno === item.itemSqno"></textarea>
                </template>
            </div>
          </div>
        </template>
        </div>
        <div class="btnWrap"  v-if="info.status === 'ing'">
          <button type="button" class="red" @click="regSurvey">설문제출</button>
        </div>
          </section>

      </div>
</template>

<script>
export default {
  name: "SurveyView",

  data() {
      return{
          status: '',
          txt: false,
          txtCnt:'',
          txtCnt2:0,
          info:[],
          list:[],
          optionList:[],
          srvySqno : this.$route.query.srvySqno,
          reload: true,
      };
  },

  methods: {


    disableEtc : function(index){ //선택형에서 기타 선택 시
       if(this.optionList[index].chkE == "E") {
         return false;
       } else {
         return true;
       }

    } , 

    disableChk : function(){ //진행중이 아닐 시에는 설문 Disable
       if(this.info[0].status === "ing") {
         return false;
       } else {
         return true;
       }

    } , 

    picked: function(index){ //단일 선택형에서 선택 된 문항 표시
      if(this.optionList[index].userPick == this.optionList[index].optnSqno) {
        this.optionList[index].chkOptnSqno = this.optionList[index].optnSqno;

        if (this.optionList[index].optnTyp =='N') {
          this.optionList[index].rply = '';
        }


      } 
      
    },

    checked: function(index){ //복수선택형에서 선택 된 문항 표시
      if(this.optionList[index].userPick == this.optionList[index].optnSqno) {
        this.optionList[index].chkOptnSqno = this.optionList[index].chkBoxSqno;

        if (this.optionList[index].optnTyp =='N') {
          this.optionList[index].rply = '';
        }
        
      } 
      
    },

    selectSearch: function(val , index){
        this.optionList[index].insertFlag='Y';
        this.optionList[index].rply=val;
    },
    selectDefault: function(index){
        if(this.optionList[index].userPick != '0' && this.optionList[index].userPick != null) {
          this.optionList[index].insertFlag='Y';
          return this.optionList[index].rply
        } else {
          return '선택하세요'
        }
    },

    
     makeSelect: function(itemSqno){ //순위형 설문 셀렉트박스 생성
        
        var selectList =  this.optionList.filter(function (element) { return element.itemSqno ==  itemSqno});
        var selectList2 = [];
        selectList.forEach(function(data) {
          var option = {text : data.optnSqno , value : data.optnSqno }
            selectList2.push(option);
         });
        return selectList2;

    },
    chkLength: function(itemSqno){ //순위형 선택 가능한 최대 갯수
      var cnttt =  this.optionList.filter(function (element) { return element.itemSqno ==  itemSqno});
      return cnttt.length;
    },
    chkTxt :function(index) { //단문 , 장문형 널값 체크
         if(this.optionList[index].rply !='' && this.optionList[index].rply != null) {
            this.optionList[index].insertFlag='Y';
          } else {
            this.optionList[index].insertFlag='N';
          }
    },


    chkEtc1 :function(index  , itemSqno, optnTyp ) { //단일 선택형 체크된 값 가져오기 
          
      for (var i = 0; i < this.optionList.length; i++) {
        if(this.optionList[i].itemSqno == itemSqno) {

            if(this.optionList[i].optnSqno == this.optionList[index].optnSqno) {

              this.optionList[index].insertFlag = 'Y';
              if (optnTyp !='E') {
                this.optionList[i].rply='';
                this.optionList[i].chkE='N';
              } else {
                  this.optionList[i].chkE='E';
                }

            } else {
                this.optionList[i].rply='';
                this.optionList[i].chkE='N';
                this.optionList[i].insertFlag = 'N';
          }
        }
      }
    } ,

    chkEtc2 :function(index , optnTyp ) { //복수 선택형 체크된 값 가져오기

          if(!this.optionList[index].chkBoxSqno) {
              this.optionList[index].insertFlag = 'Y';
              if (optnTyp !='E') {
                this.optionList[index].rply='';
                this.optionList[index].chkE='N';
              } else {
                this.optionList[index].chkE='E';
              }
          } else {
                this.optionList[index].insertFlag = 'N';
                this.optionList[index].rply='';
                this.optionList[index].chkE='N';
          }
    } ,

    regSurvey : function(){
        var that = this;
        var insertList = that.optionList.filter(function (element) { return element.insertFlag ==  'Y'});
        var essnList = that.list.filter(function (element) { return element.essnYn ==  'Y'});

        console.log(insertList);

      for (var v = 0; v < essnList.length; v++) {
         var validateEssnList = insertList.filter(function (element) { return element.itemSqno == essnList[v].itemSqno});
        if(validateEssnList.length == 0) {
             alert("필수 설문을 완료해주세요.");
             this.focus(essnList[v].itemSqno);
             return false;
        }
    }


      for (var i = 0; i < that.list.length; i++) {
         var validateList = insertList.filter(function (element) { return element.itemSqno == that.list[i].itemSqno});

        //순위형 중복 입력했을때
        if(that.list[i].qsitTypCd == 'SQT04'){
         for (var j = 0; j < validateList.length; j++) {
           for (var k = 0; k < j; k++) {
              if (validateList[j].rply ==validateList[k].rply) {
                alert("순위형 설문에 같은 순위를 입력할 수 없습니다.");
                 return false;
              }
           }
         }
        }


        if(that.list[i].qsitTypCd == 'SQT01' || that.list[i].qsitTypCd == 'SQT02'){
            for (var h = 0; h < validateList.length; h++) {
              if(validateList[h].chkE == 'E' && (validateList[h].rply == '' || validateList[h].rply == undefined)) {
                  alert("기타 내용을 입력해주세요.");
                  return false;
              }
            }
        }

      }


			if(confirm("설문을 제출 하시겠습니까?")){

      var jsonString = JSON.stringify(insertList);
      console.log(insertList);
      console.log(jsonString);

      var param = {};
      param.jsonString = jsonString;

				this.$api.mypage
				.saveSurvey(param)
				.then(function(data) {

					if(data && data > 0){
						alert("작성 설문은 마이페이지에서 확인이 가능합니다.");
            that.beforeClose();
					}else{
						alert("제출에 실패했습니다.");
					}

				})
        .catch(function(error) {
          alert(error.rtMsg);
        });
        
        
			}
		}
    ,beforeClose :function(){
      this.$router.back();
    },

   focus(val){
      var d = document.getElementById('div'+val);
      var topPos = d.offsetTop - 110;
      window.scrollTo({top:topPos});
  }

  },
    created: function() {
      if(this.$route.query.from){
        this.reload=false
      }

      var that = this
      var parameters = {
        'srvySqno': this.$route.query.srvySqno
      };
      this.$api.mypage
      .view(parameters)
      .then(function(data) {
        
         console.log(data)
          that.info = data.info;   //API에서 가져온 항목리스트
          that.list = data.list;   //API에서 가져온 항목리스트
          that.optionList = data.optionList;   //API에서 가져온 보기리스트

        })
      .catch(function(error) {
          alert(error.rtMsg);
          
      });

    },


};

</script>
